import { Loader2, X } from "lucide-react";

// The headline and the title bar are one header. Close is the panel, not the download note.
export function Section180PanelHeader(props: {
  selectedCount: number;
  singleFieldName: string | undefined;
  busy: boolean;
  onClose: () => void;
}) {
  const { selectedCount, singleFieldName, busy, onClose } = props;
  return (
    <>
      {/* the big centered headline question — same slot as the Map Soil panel's */}
      <div className="border-b border-line px-3 py-2 text-center">
        <h1 className="text-lg font-bold text-fg sm:text-xl">
          Use ROGO&rsquo;s Report, or Build Your Own?
        </h1>
      </div>
      <div className="relative flex items-center gap-3 border-b border-line px-3 py-1.5">
        <h2 className="text-[13px] font-semibold">
          File Section 180{" "}
          <span className="font-normal text-muted">
            —{" "}
            {selectedCount === 1 ? singleFieldName : `${selectedCount} fields`}
          </span>
        </h2>
        {busy && (
          <span className="flex items-center gap-1 text-[11px] text-muted">
            <Loader2 size={11} className="animate-spin text-accent" /> working…
          </span>
        )}
        <button
          onClick={onClose}
          className="ml-auto rounded p-1 hover:bg-hover"
          aria-label="Close"
        >
          <X size={16} />
        </button>
      </div>
    </>
  );
}
